import {
  Text,
  Image,
  LicensePlate,
  Button,
} from "../Index";
import CloseIcon from "../../assets/Icon/close.svg";
import FallbackCarImage from "../../assets/Image/car-image.webp";
import "./carDetailsPopup.scss";

// Reusable popup showing the actual registered information of one car.
// Follows the existing RTL / Vazir / theme / spacing / UI style
// (same overlay + header + close-button language as SelectCarPop).
function CarDetailsPopup({ car, isOpen, onClose }) {
  if (!isOpen || !car) return null;

  const fallback = "نامشخص";

  const rows = [
    { label: "مدل ماشین", value: car.CarModel || car.title || fallback },
    {
      label: "سال ساخت",
      value: car.ProductionYear || car.buildYear || fallback,
    },
    { label: "رنگ", value: car.CarColor || car.color || fallback },
    { label: "کیلومتر", value: car.Km ?? car.currentMileage ?? fallback },
    { label: "شماره شاسی", value: car.chassisNumber || fallback },
  ];

  const hasPlate =
    car.Plate1 || car.Plate2 || car.Plate3 || car.End;

  return (
    <div
      className="car-details-pop-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="جزئیات خودرو"
    >
      <div
        className="car-details-pop-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="car-details-pop-header">
          <Text FontWight="Bold" FontSize="lg" position="right">
            جزئیات خودرو
          </Text>
          <button
            className="car-details-pop-close"
            onClick={onClose}
            aria-label="بستن"
            type="button"
          >
            <img src={CloseIcon} alt="" />
          </button>
        </div>

        <div className="car-details-pop-body">
          <div className="car-details-pop-image-wrapper">
            <Image src={car.Src || car.image || FallbackCarImage} />
          </div>

          {rows.map((row) => (
            <div key={row.label} className="car-details-pop-row">
              <Text FontSize="sm" position="right" className="car-details-pop-label">
                {row.label}:
              </Text>
              <Text FontWight="Bold" FontSize="md" position="right">
                {String(row.value)}
              </Text>
            </div>
          ))}

          {hasPlate ? (
            <div className="car-details-pop-plate">
              <LicensePlate
                Main1={car.Plate1}
                Main2={car.Plate2}
                Main3={car.Plate3}
                End={car.End}
              />
            </div>
          ) : null}
        </div>

        <div className="car-details-pop-footer">
          <Button size="full" color="dark" onClick={onClose}>
            بستن
          </Button>
        </div>
      </div>
    </div>
  );
}

export default CarDetailsPopup;
